module.exports = __webpack_public_path__ + "media/bootstrap-icons/sim-fill-297bfeba.svg";